<div class="companyes_page">
    <div class="cases_page" style="margin-bottom: 4px;">
        <div class="container">
          <div class="filter_out">  
            <div class="filter_values">
                <div class="d-f-c">

                </div>
      
              <div class="stats_wrp">
                <div class="tasks_counters">
                    <div class="counter_block" *ngIf="pagination && pagination['totalCount']" (click)="log()">
                        <div class="counter_top">{{ "Scenarios" | translate }}</div>
                        <div class="counter_bottom">{{scenarios?.length || 0}} / <b>{{pagination['totalCount']}}</b></div>
                    </div>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="sortBtn" class="mobActiveFilter ml-1" #tooltip="matTooltip" matTooltip="{{ 'Sort' | translate }}" [matTooltipPosition]="'above'">
                        <mat-icon>sort</mat-icon>
                    </button>
                    <mat-menu #sortBtn="matMenu" class="sort_tablet" xPosition='before' overlayPanelClass='sortTAB'>
                        <div class="mat-menu-title">{{"Sort By" | translate}}:</div>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="sort('')" [ngClass]="{'active_status': sortValue === ''}">
                            {{  "Default" | translate }}
                        </button>
                        <button mat-menu-item (click)="sort(sortValue == 'executed_at_desc' ? 'executed_at' : 'executed_at_desc')" [ngClass]="{'active_status': sortValue == 'executed_at_desc' || sortValue == 'executed_at'}">
                            {{  "Executed" | translate }}
                            <div class="d-f-c ml-1">
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('executed_at_desc')" [ngClass]="{'active': sortValue == 'executed_at_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('executed_at')" [ngClass]="{'active': sortValue == 'executed_at'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                            </div>
                        </button>
                        <button mat-menu-item (click)="sort(sortValue == 'queued_at_desc' ? 'queued_at' : 'queued_at_desc')" [ngClass]="{'active_status': sortValue == 'queued_at_desc' || sortValue == 'queued_at'}">
                            {{  "Queued" | translate }}
                            <div class="d-f-c ml-1">
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('queued_at_desc')" [ngClass]="{'active': sortValue == 'queued_at_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('queued_at')" [ngClass]="{'active': sortValue == 'queued_at'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                            </div>
                        </button>
                        <button mat-menu-item (click)="sort(sortValue == 'checked_at_desc' ? 'checked_at' : 'checked_at_desc')" [ngClass]="{'active_status': sortValue == 'checked_at_desc' || sortValue == 'checked_at'}">
                            {{  "Checked" | translate }}
                            <div class="d-f-c ml-1">
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('checked_at_desc')" [ngClass]="{'active': sortValue == 'checked_at_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
                                <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('checked_at')" [ngClass]="{'active': sortValue == 'checked_at'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
                            </div>
                        </button>
                    </mat-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div        
    class="root_users root_plans"  
    [appDeviceClass]="'custom-scroll custom-scroll-t'"      
    infinite-scroll
    [infiniteScrollDisabled]="isLoad"
    [scrollWindow]="false"
    [infiniteScrollUpDistance]="scrollUpDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="onDownScenarios($event)">
        <div class="server_item_out server_item_out_head">
            <form [formGroup]="scenariosFilter" class="server_item trans_item plan_item">
                <div class="d-f-c">
                    <div class="id" style="flex-direction: column;">
                        <div>
                            {{ "ID" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <!-- <mat-label>{{ 'Tags' | translate }}</mat-label> -->
                            <input type="text" matInput formControlName="template_id" (change)="filterScenarios()" style="border: .5px solid #ccc; margin-top: 2px;">
                        </mat-form-field>
                    </div>
                    <div class="date">
                        {{ "Date" | translate }}
                    </div>
                    <div class="date" style="flex-direction: column;">
                        {{ "Executed At" | translate }}

                        <div class="date_fil" (click)="rangePicker.open()">
                            <mat-icon>date_range</mat-icon>
                            <div class="d-f-c">
                                <div>{{scenariosFilter.get('executed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                                <div class="ml-5 mr-5">-</div>
                                <div>{{scenariosFilter.get('executed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                            </div>
                        </div>
                        <mat-form-field appearance="legacy" class="example-form-field hide-form-field">
                            <!-- <mat-label>{{ 'Date' | translate }}</mat-label> -->
                            <mat-date-range-input [rangePicker]="rangePicker" style="display: none;">
                                <input formControlName="executed_at_from" (dateChange)="onStartDateChange($event)" matStartDate placeholder="{{ 'Date from' | translate }}">
                                <input formControlName="executed_at_to" (dateChange)="onEndDateChange($event)" matEndDate placeholder="{{ 'Date to' | translate }}">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matPrefix [for]="rangePicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #rangePicker>
                                <mat-date-range-picker-actions>
                                    <button mat-button matDateRangePickerCancel>Cancel</button>
                                    <button class="ml-5" mat-raised-button color="warn" (click)="resetFil('executed'); rangePicker.close()">Reset</button>
                                    <button class="ml-5" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                </mat-date-range-picker-actions>
                            </mat-date-range-picker>
                        </mat-form-field>
                    </div>
                    <div class="date">
                        {{ "Queued At" | translate }}
                        <div class="date_fil" (click)="rangePickerQ.open()">
                            <mat-icon>date_range</mat-icon>
                            <div class="d-f-c">
                                <div>{{scenariosFilter.get('queued_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                                <div class="ml-5 mr-5">-</div>
                                <div>{{scenariosFilter.get('queued_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                            </div>
                        </div>
                        <mat-form-field appearance="legacy" class="example-form-field hide-form-field">
                            <!-- <mat-label>{{ 'Date' | translate }}</mat-label> -->
                            <mat-date-range-input [rangePicker]="rangePickerQ" style="display: none;">
                                <input formControlName="queued_at_from" (dateChange)="onStartDateChange($event)" matStartDate placeholder="{{ 'Date from' | translate }}">
                                <input formControlName="queued_at_to" (dateChange)="onEndDateChange($event)" matEndDate placeholder="{{ 'Date to' | translate }}">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matPrefix [for]="rangePickerQ"></mat-datepicker-toggle>
                            <mat-date-range-picker #rangePickerQ>
                              <mat-date-range-picker-actions>
                                <button mat-button matDateRangePickerCancel>Cancel</button>
                                <button class="ml-5" mat-raised-button color="warn" (click)="resetFil('queued'); rangePickerQ.close()">Reset</button>
                                <button class="ml-5" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                              </mat-date-range-picker-actions>
                            </mat-date-range-picker>
                        </mat-form-field>
                    </div>         
                    <div class="date">
                        {{ "Checked At" | translate }}
                        <div class="date_fil" (click)="rangePickerCh.open()">
                            <mat-icon>date_range</mat-icon>
                            <div class="d-f-c">
                                <div>{{scenariosFilter.get('checked_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                                <div class="ml-5 mr-5">-</div>
                                <div>{{scenariosFilter.get('checked_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe}}</div>
                            </div>
                        </div>
                        <mat-form-field appearance="legacy" class="example-form-field hide-form-field">
                            <!-- <mat-label>{{ 'Date' | translate }}</mat-label> -->
                            <mat-date-range-input [rangePicker]="rangePickerCh" style="display: none;">
                                <input formControlName="checked_at_from" (dateChange)="onStartDateChange($event)" matStartDate placeholder="{{ 'Date from' | translate }}">
                                <input formControlName="checked_at_to" (dateChange)="onEndDateChange($event)" matEndDate placeholder="{{ 'Date to' | translate }}">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matPrefix [for]="rangePickerCh"></mat-datepicker-toggle>
                            <mat-date-range-picker #rangePickerCh>
                                <mat-date-range-picker-actions>
                                    <button mat-button matDateRangePickerCancel>Cancel</button>
                                    <button class="ml-5" mat-raised-button color="warn" (click)="resetFil('checked'); rangePickerCh.close()">Reset</button>
                                    <button class="ml-5" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                </mat-date-range-picker-actions>
                            </mat-date-range-picker>
                        </mat-form-field>
                    </div>         
                    <div class="msg" style="flex-direction: column;">
                        <div>
                            {{ "Type" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="scenario_name" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="scName" *ngFor="let scName of scenarioNames">
                                    {{ scName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>     
                    <div class="msg">
                        {{ "Scenario Title" | translate }}
                    </div>     
                    <div class="is_col is_col_id" style="flex-direction: column;">
                        <div>
                            {{ "Card ID" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <!-- <mat-label>{{ 'Tags' | translate }}</mat-label> -->
                            <input type="text" matInput formControlName="task_id" (change)="filterScenarios()" style="border: .5px solid #ccc; margin-top: 2px;">
                        </mat-form-field>
                    </div>      
                    <div class="is_col is_col_id" style="flex-direction: column;">
                        <div>
                            {{ "Job ID" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <!-- <mat-label>{{ 'Tags' | translate }}</mat-label> -->
                            <input type="text" matInput formControlName="task_operation_id" (change)="filterScenarios()" style="border: .5px solid #ccc; margin-top: 2px;">
                        </mat-form-field>
                    </div>      
                    <div class="is_col" style="flex-direction: column;">
                        <div #tooltip="matTooltip" matTooltip="{{ 'Completed_h' | translate }}" [matTooltipPosition]="'above'">
                            {{ "Active" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="is_active" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="1">
                                    {{ 'Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="0">
                                    {{ 'No' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>   

                    <div class="is_col" style="flex-direction: column;">
                        <div #tooltip="matTooltip" matTooltip="{{ 'Queued for execution' | translate }}" [matTooltipPosition]="'above'">
                            {{ "In queue" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="is_in_queue" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="1">
                                    {{ 'Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="0">
                                    {{ 'No' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="is_col" style="flex-direction: column;">
                        <div #tooltip="matTooltip" matTooltip="{{ 'In progress' | translate }}" [matTooltipPosition]="'above'">
                            {{ "Running" | translate }}
                        </div>
                        <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="is_running" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="1">
                                    {{ 'Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="0">
                                    {{ 'No' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="is_col" style="flex-direction: column;">
                        <div #tooltip="matTooltip" matTooltip="{{ 'Executing at a set interval' | translate }}" [matTooltipPosition]="'above'">
                            {{ "Interval" | translate }}
                        </div>
                        <!-- <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="is_interval" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="1">
                                    {{ 'Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="0">
                                    {{ 'No' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field> -->
                    </div>
                    <div class="is_col" style="flex-direction: column;">
                        <div #tooltip="matTooltip" matTooltip="{{ 'May run after deactivation' | translate }}" [matTooltipPosition]="'above'">
                            {{ "Resident" | translate }}
                        </div>
                        <!-- <mat-form-field appearance="outline" class="report_filter">
                            <mat-select [disableOptionCentering]="true" selectDir formControlName="is_resident" (selectionChange)="filterScenarios()">
                                <mat-option [value]="''">
                                    {{ 'All' | translate }}
                                </mat-option>
                                <mat-option [value]="1">
                                    {{ 'Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="0">
                                    {{ 'No' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field> -->
                    </div>
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between !important; width: 40px;" *ngIf="user?.is_root">
                    <div style="padding-right: 10px;">
                        {{ "Action" | translate }}
                    </div>
                    <!-- <div class="check_wrp hidden_log">
                        <mat-checkbox color="primary" class="example-margin" (click)="$event.stopPropagation()"></mat-checkbox>
                    </div> -->
                </div>
            </form>
        </div>
        <ng-container *ngIf="scenarios?.length">
            <div class="server_item_out" *ngFor="let item of scenarios; let i = index;">
                <div class="server_item plan_item trans_item">
                    <div class="d-f-c">
                        <div class="id">
                            {{ item?.template_id }}
                        </div>
                        <div class="date">
                            <div class="date_line">
                                <mat-icon style="color: #686868;" class="mr-5 icon_10">add</mat-icon>
                                <ng-container *ngIf="item?.created_at > today && item?.created_at < todayEnd; else createdAtTempl">
                                    <span #tooltip="matTooltip"
                                    matTooltip="{{ item?.created_at*1000 | date:'MMM d, y':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.created_at*1000 | date:'hh:mm a':'':activeLang }}
                                    </span>
                                </ng-container>
                                <ng-template #createdAtTempl>
                                    <span *ngIf="item?.created_at && item?.created_at > 30000" #tooltip="matTooltip"
                                    matTooltip="{{ item?.created_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.created_at*1000 | date:'MMM dd, Y':'': activeLang }}
                                    </span>
                                </ng-template>
                            </div>

                            <div class="date_line">
                                <mat-icon style="color: #686868;" class="mr-5 icon_10">edit</mat-icon>
                                <ng-container *ngIf="item?.updated_at > today && item?.updated_at < todayEnd; else updAtTempl">
                                    <span #tooltip="matTooltip"
                                        matTooltip="{{ item?.updated_at*1000 | date:'MMM d, y':'':activeLang | yearPipe }}"
                                        [matTooltipPosition]="'above'">
                                        {{ item?.updated_at*1000 | date:'hh:mm a':'':activeLang }}
                                    </span>
                                </ng-container>
                                <ng-template #updAtTempl>
                                    <span *ngIf="item?.updated_at && item?.updated_at > 30000" #tooltip="matTooltip"
                                    matTooltip="{{ item?.updated_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.updated_at*1000 | date:'MMM dd, Y':'': activeLang }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                        <div class="date">
                            <div class="date_line">
                                <ng-container *ngIf="item?.executed_at > today && item?.executed_at < todayEnd; else excAtTempl">
                                    <span #tooltip="matTooltip"
                                    matTooltip="{{ item?.executed_at*1000 | date:'MMM d, y':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.executed_at*1000 | date:'hh:mm a':'':activeLang }}
                                    </span>
                                </ng-container>
                                <ng-template #excAtTempl>
                                    <span *ngIf="item?.executed_at && item?.executed_at > 30000" #tooltip="matTooltip"
                                    matTooltip="{{ item?.executed_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.executed_at*1000 | date:'MMM dd, Y':'': activeLang }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                        <div class="date">
                            <div class="date_line">
                                <ng-container *ngIf="item?.queued_at > today && item?.queued_at < todayEnd; else queAtTempl">
                                    <span #tooltip="matTooltip"
                                    matTooltip="{{ item?.queued_at*1000 | date:'MMM d, y':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.queued_at*1000 | date:'hh:mm a':'':activeLang }}
                                    </span>
                                </ng-container>
                                <ng-template #queAtTempl>
                                    <span *ngIf="item?.queued_at && item?.queued_at > 30000" #tooltip="matTooltip"
                                    matTooltip="{{ item?.queued_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.queued_at*1000 | date:'MMM dd, Y':'': activeLang }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>         
                        <div class="date">
                            <div class="date_line">
                                <ng-container *ngIf="item?.checked_at > today && item?.checked_at < todayEnd; else chckAtTempl">
                                    <span #tooltip="matTooltip"
                                    matTooltip="{{ item?.checked_at*1000 | date:'MMM d, y':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.checked_at*1000 | date:'hh:mm a':'':activeLang }}
                                    </span>
                                </ng-container>
                                <ng-template #chckAtTempl>
                                    <span *ngIf="item?.checked_at && item?.checked_at > 30000" #tooltip="matTooltip"
                                    matTooltip="{{ item?.checked_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}"
                                    [matTooltipPosition]="'above'">
                                    {{ item?.checked_at*1000 | date:'MMM dd, Y':'': activeLang }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>         
                        <div class="msg">
                            <div class="text_one_line scen_type">
                                {{ item?.scenario_name }}
                            </div>
                        </div>     
                        <div class="msg">
                            <div class="text_2_line scen_name">
                                {{ item?.template?.name }}
                            </div>
                        </div>     

                        <div class="is_col is_col_id">
                            <div class="d-f-c">
                                <span class="cp" style="color: rgb(22, 73, 139);" (click)="openTask(item, item?.task_id)">
                                    {{item?.task_id}}
                                </span>
                                <mat-spinner class="spin_16 ml-1" *ngIf="!!item?.cardLoad"></mat-spinner>  
                            </div>
                        </div>  
                        <div class="is_col is_col_id">
                            <div class="d-f-c">
                                <span class="cp" style="color: rgb(22, 73, 139);" (click)="openJob(item, item?.task_operation_id)">
                                    {{item?.task_operation_id}}
                                </span>
                                <mat-spinner class="spin_16 ml-1" *ngIf="!!item?.jobLoad"></mat-spinner>  
                            </div>
                        </div>     

                        <div class="is_col">
                            <mat-icon #tooltip="matTooltip" matTooltip="{{ (!!item?.is_active ? 'Waiting for conditions to be met, not completed' : 'Completed, will not run again') | translate }}" [matTooltipPosition]="'above'">{{!!item?.is_active ? 'done' : 'close'}}</mat-icon>
                        </div>   
                        <div class="is_col">
                            <mat-icon #tooltip="matTooltip" matTooltip="{{ (!!item?.is_in_queue ? 'Queued for execution' : 'Not queued for execution') | translate }}" [matTooltipPosition]="'above'">{{!!item?.is_in_queue ? 'done' : 'close'}}</mat-icon>
                        </div>       
                        <div class="is_col">
                            <mat-icon #tooltip="matTooltip" matTooltip="{{ (!!item?.is_running ? 'In progress' : 'Not running') | translate }}" [matTooltipPosition]="'above'">{{!!item?.is_running ? 'done' : 'close'}}</mat-icon>
                        </div>       
                        <div class="is_col">
                            <mat-icon #tooltip="matTooltip" matTooltip="{{ (!!item?.is_interval ? 'Executing at a set interval' : 'Not executing at a set interval') | translate }}" [matTooltipPosition]="'above'">{{!!item?.is_interval ? 'done' : 'close'}}</mat-icon>
                        </div>       
                        <div class="is_col">
                            <mat-icon #tooltip="matTooltip" matTooltip="{{ (!!item?.is_resident ? 'May run after deactivation' : 'Do not run after deactivation') | translate }}" [matTooltipPosition]="'above'">{{!!item?.is_resident ? 'done' : 'close'}}</mat-icon>
                        </div>       
                    </div>
                    <div style="display: flex; align-items: center; justify-content: flex-end !important;" *ngIf="user?.is_root">
                        <button mat-icon-button style="color: #686868;" (click)="item.isOpen = !item.isOpen">
                            <mat-icon>
                                {{ item?.isOpen ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </button> 
                    </div>
                </div>
                <div class="server_item_log" *ngIf="item.isOpen && !!user?.is_root" [appDeviceClass]="'custom-scroll custom-scroll-t'">
                    <pre>
                        {{item|json}}
                    </pre>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- <div style="padding: 15px 0;">
        <button class="add_btn" mat-raised-button color="primary" (click)="addRootTransaction()">
            <mat-icon>add</mat-icon>
            {{ "Transaction" | translate }}
        </button>
    </div> -->
</div>
<mat-progress-bar mode="indeterminate" *ngIf="isLoad" class="mat_proggress_w8 cases_progress"></mat-progress-bar>